import { Box, Stack } from "@mui/material";
import ComingSoonFeature from "../../components/common/ComingSoonFeature";

const Settings = () => {
  return (
    <Box>
      <Stack spacing={4}>
        {/* Calendar Feature */}
        <Box>
          <ComingSoonFeature
            featureName="SETTINGS"
            skeletonType="list"
            description="Advanced settings management and analytics coming soon!"
            height={650}
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default Settings;
